import React from 'react'

const imgAtom02 = '/icon/atom-02.svg'
const imgGroup = '/notifyer-integration.svg'
const imgMakeIconJpeg = '/Shopify.jpg'
const imgMakeIconJpeg1 = '/make.jpg'
const imgRectangle12319769 = '/restapi.png'
const imgMondayJpeg = '/monday.jpeg'
const imgZapierIconJpeg = '/Zapier.jpg'
const imgIconPng = '/n8n.png'
const imgPipedriveMonogramLogoLight = '/pipedrive.svg'
const imgPipedrivePartnerBadge = '/pipedrive-partner-badge.svg'
const imgMaterialSymbolsPlugConnect = '/icon/material-symbols-plug-connect.svg'
const imgFluentMolecule16Filled = '/icon/fluent-molecule-16-filled.svg'
const imgTablerMessageFilled = '/icon/tabler-message-filled.svg'
const imgMageRocketFill = '/icon/mage-rocket-fill.svg'

const logoCards = [
  { name: 'Shopify', src: imgMakeIconJpeg, bg: 'bg-white', ring: 'ring-[rgba(28,35,41,0.3)]' },
  { name: 'Make', src: imgMakeIconJpeg1, bg: 'bg-white', ring: 'ring-[rgba(28,35,41,0.3)]' },
  { name: 'Monday', src: imgMondayJpeg, bg: 'bg-white', ring: 'ring-[rgba(28,35,41,0.3)]' },
  { name: 'Pipedrive', src: imgPipedriveMonogramLogoLight, bg: 'bg-[#26292c]', ring: 'ring-[rgba(28,35,41,0.3)]' },
  { name: 'Zapier', src: imgZapierIconJpeg, bg: 'bg-white', ring: 'ring-[rgba(28,35,41,0.3)]' },
  { name: 'n8n', src: imgIconPng, bg: 'bg-white', ring: 'ring-[rgba(28,35,41,0.3)]' },
]

const steps = [
  {
    icon: imgMaterialSymbolsPlugConnect,
    title: '1. Connect Your WhatsApp',
    desc: "Link your existing WhatsApp Business account. Simply scan a QR code to automate.",
  },
  {
    icon: imgFluentMolecule16Filled,
    title: '2. Set Up Integrations',
    desc: 'Connect with Zapier, Make, n8n, Monday, or use our REST API to automate your workflows and trigger messages, keeping your CRM up to date with all messages appearing there.',
  },
  {
    icon: imgTablerMessageFilled,
    title: '3. Create Your Messages',
    desc: 'Design your message templates, set up sequences, and configure automated follow-ups for your needs.',
  },
  {
    icon: imgMageRocketFill,
    title: '4. Launch & Monitor',
    desc: 'Start sending messages and monitor performance with real-time analytics, delivery rates, and response tracking.',
  },
]

const Integrations = () => {
  const connectorAnimation = `
    @keyframes connector-move-horizontal {
      0% {
        left: 0;
      }
      100% {
        left: calc(100% - 35px);
      }
    }
    @keyframes connector-move-vertical {
      0% {
        top: 0;
      }
      100% {
        top: calc(100% - 35px);
      }
    }
  `

  return (
    <section id="integrations" className="scroll-mt-20 bg-white px-6 py-10 sm:px-10 sm:py-12 lg:px-[100px] lg:py-16">
      <div className="mx-auto flex max-w-[1240px] flex-col items-center gap-8 text-center sm:gap-10 lg:gap-14">
        <style>{connectorAnimation}</style>
        {/* Pill */}
        <div className="flex items-center gap-2 rounded-full bg-[#fafafa] px-4 py-2 text-xs font-medium uppercase tracking-[0.28px] text-[#1c2329] shadow-[inset_0px_1px_1px_rgba(26,32,50,0.1),inset_0px_1px_2px_rgba(26,32,50,0.05)]">
          <img src={imgAtom02} alt="" className="h-6 w-6" />
          <span>Integrations</span>
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h2 className="text-[32px] font-semibold leading-tight tracking-[-1px] text-[#1c2329] sm:text-[40px] md:text-[48px] lg:text-[56px]">
            Powerful integrations
          </h2>
          <p className="text-[16px] leading-[1.7] tracking-[-0.5px] text-[#656f68] sm:text-[17px]">
            Connect Notifyer with your favorite tools and automate your entire workflow
          </p>
        </div>

        {/* Logos with connector - Mobile: Vertical, Desktop: Horizontal */}
        <div className="w-full overflow-visible">
          <div className="relative mx-auto flex max-w-[1240px] flex-col items-center justify-center gap-4 px-2 pt-4 lg:flex-row lg:flex-nowrap lg:items-center lg:justify-center lg:gap-8 lg:pt-6">
            {/* Vertical connector for mobile */}
            <div className="absolute left-1/2 top-0 bottom-0 z-0 -translate-x-1/2 lg:hidden">
              <div className="relative h-full w-[6px]">
                <div
                  className="absolute left-0 top-0 h-[35px] w-[6px] rounded-full bg-[#01cd74] z-10 pointer-events-none"
                  style={{ 
                    animation: 'connector-move-vertical 1.5s linear infinite alternate',
                    willChange: 'top'
                  }}
                />
              </div>
            </div>

            {/* Horizontal connector for desktop */}
            <div className="absolute left-[33%] right-[33%] top-1/2 z-0 -translate-y-1/2 hidden lg:block">
              <div className="relative h-[6px] w-full">
                <div
                  className="absolute top-0 left-0 h-[6px] w-[35px] rounded-full bg-[#01cd74] z-10 pointer-events-none"
                  style={{ animation: 'connector-move-horizontal 2s linear infinite alternate', willChange: 'left' }}
                />
              </div>
            </div>

            {/* Top row - 3 logos (mobile) / Left side (desktop) */}
            <div className="flex w-full justify-center">
              <div className="inline-grid w-full max-w-[360px] grid-cols-3 place-items-center gap-3 sm:gap-4 lg:w-auto lg:max-w-none lg:grid-cols-3 lg:gap-6">
                {logoCards.slice(0, 3).map((logo) => (
                  <div
                    key={logo.name}
                    className="relative z-10 flex size-[90px] flex-col items-center justify-center gap-2 rounded-[12px] border border-dashed border-[rgba(28,35,41,0.3)] bg-white p-3 shadow-[0px_8px_8px_rgba(36,211,102,0.08)] sm:size-[100px] lg:size-[140px] lg:gap-3 lg:rounded-[16px] lg:p-4"
                  >
                    <div className={`flex size-[40px] items-center justify-center rounded-full sm:size-[44px] lg:size-[64px] ${logo.bg}`}>
                      {logo.mask ? (
                        <div className="relative size-[32px] overflow-hidden rounded-full bg-white lg:size-[40px]">
                          <img src={logo.src} alt={logo.name} className="absolute inset-0 h-full w-full object-cover" />
                        </div>
                      ) : (
                        <img src={logo.src} alt={logo.name} className="h-full w-full object-contain rounded-full" />
                      )}
                    </div>
                    <p className="text-[12px] font-normal tracking-[-0.36px] text-[#1c2329] sm:text-[14px] lg:text-[18px] lg:tracking-[-0.54px]">{logo.name}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Notifyer logo - center */}
            <img src={imgGroup} alt="Notifyer" className="relative z-10 size-[80px] object-contain sm:size-[90px] lg:size-[120px]" />

            {/* Bottom row - 3 logos (mobile) / Right side (desktop) */}
            <div className="flex w-full justify-center overflow-visible">
              <div className="inline-grid w-full max-w-[360px] grid-cols-3 place-items-center gap-3 sm:gap-4 lg:w-auto lg:max-w-none lg:grid-cols-3 lg:gap-6 overflow-visible pt-2 sm:pt-2.5 lg:pt-3">
                {logoCards.slice(3).map((logo) => {
                  const pipedriveUrl = 'https://www.pipedrive.com/en/marketplace/app/whats-able-whats-app-automation-with-pipedrive-ai/3be2f03344cc1c9f'
                  const isPipedrive = logo.name === 'Pipedrive'
                  const cardClass = `relative z-10 flex size-[90px] flex-col items-center justify-center gap-2 rounded-[12px] border border-dashed border-[rgba(28,35,41,0.3)] bg-white p-3 shadow-[0px_8px_8px_rgba(36,211,102,0.08)] sm:size-[100px] lg:size-[140px] lg:gap-3 lg:rounded-[16px] lg:p-4 ${isPipedrive ? 'overflow-visible transition-shadow duration-200 hover:shadow-[0px_10px_24px_rgba(36,211,102,0.15)] cursor-pointer' : ''}`
                  const content = (
                    <>
                      {isPipedrive && (
                        <span
                          className="absolute -top-2 -right-2 z-20 transition-transform duration-200 group-hover:scale-110 sm:-top-2.5 sm:-right-2.5 lg:-top-3 lg:-right-3 pointer-events-none"
                          aria-hidden
                        >
                          <img
                            src={imgPipedrivePartnerBadge}
                            alt=""
                            className="h-8 w-8 sm:h-9 sm:w-9 lg:h-12 lg:w-12 object-contain drop-shadow-[0px_2px_8px_rgba(0,0,0,0.15)]"
                          />
                        </span>
                      )}
                      <div className={`flex size-[40px] items-center justify-center rounded-full sm:size-[44px] lg:size-[64px] ${logo.bg}`}>
                        <img src={logo.src} alt={logo.name} className="h-full w-full object-contain rounded-full" />
                      </div>
                      <p className="text-[12px] font-normal tracking-[-0.36px] text-[#1c2329] sm:text-[14px] lg:text-[18px] lg:tracking-[-0.54px]">{logo.name}</p>
                    </>
                  )
                  return isPipedrive ? (
                    <a
                      key={logo.name}
                      href={pipedriveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`group block ${cardClass}`}
                      title="WhatsAble on Pipedrive Marketplace"
                    >
                      {content}
                    </a>
                  ) : (
                    <div key={logo.name} className={cardClass}>
                      {content}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Steps grid */}
        <div id="how-it-works" className="scroll-mt-20 w-full rounded-[16px] border border-[#f2f3f3] bg-[#fafaf9] p-2">
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-4">
            {steps.map((step) => (
              <div
                key={step.title}
                className="rounded-[10px] border border-[#f3f3f2] bg-white p-6 text-left shadow-[0px_1px_3px_rgba(0,0,0,0.04)]"
              >
                <div className="grid h-14 w-14 place-items-center rounded-full border border-[rgba(28,35,41,0.15)]">
                  <img src={step.icon} alt="" className="h-8 w-8 object-contain" />
                </div>
                <h3 className="mt-4 text-[18px] font-semibold tracking-[-0.54px] text-[#1c2329]">
                  {step.title}
                </h3>
                <p className="mt-2 text-[15px] leading-[1.6] text-[#656f68]">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Integrations